import {StorageEngine} from "./storage-engine";

class LocalEngine extends StorageEngine {
  #engine;

  constructor() {
    super();

    try {
      this.#engine = window.localStorage;
    } catch (e) {
      console.error(`Ошибка доступа к localStorage`, e);
    }
  }

  set(key, value) {
    super.set(key, value);

    try {
      if (this.#engine) {
        this.#engine.setItem(key, value);
      }
    } catch (e) {
      console.error(`Ошибка доступа к localStorage`, e);
    }
  }

  get(key) {
    super.get(key);

    try {
      if (this.#engine) {
        return this.#engine.getItem(key);
      }

      return undefined;
    } catch (e) {
      console.error(`Ошибка доступа к localStorage`, e);
      return undefined;
    }
  }

  remove(key) {
    super.remove(key);

    try {
      if (this.#engine) {
        this.#engine.removeItem(key);
      }
    } catch (e) {
      console.error(`Ошибка доступа к localStorage`, e);
    }
  }
}

export {LocalEngine};
